import { StyleSheet } from 'react-native'

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes'

export default StyleSheet.create({
  container: theme => ({
    backgroundColor: theme.colors.tintColor,
    height: 'auto',
    borderRadius: 6,
    elevation: 2,
    shadowColor: theme.colors.shadowColor,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowRadius: 4,
    shadowOpacity: 1,
    marginBottom: 12,
    paddingHorizontal: 16,
    paddingVertical: 18,
  }),
  serviceIconAndContentContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  serviceIcon: {
    resizeMode: 'contain',
    height: 48,
    width: 48,
    marginRight: 16,
  },
  titleAndSubtitleContainer: {
    width: '70%',
    justifyContent: 'space-around',
    height: 48,
    flex: 1
  },
  title: theme => ({
    fontSize: 18,
    color: theme.colors.textColor,
  }),
  subtitle: theme => ({
    fontSize: 14,
    color: theme.colors.textColorTwo,
  }),
  description: theme => ({
    fontSize: 16,
    marginTop: 9,
    // marginLeft: 65,
    lineHeight: 22,
    fontFamily: Fonts.type.VFFont,
    color: theme.colors.textColor,
  }),
})
